import { RegionShared } from "@1games-ru/region-shared";
import { FC, useState } from "react";
import AuthMpProvider from "@/core/data-provider/data-mp/auth/auth-mp-provider";
import { callServer } from "@/core/helpers/callEvent.ts";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import AuthUpdatePassword from "@/domains/auth/components/update/AuthUpdatePassword.tsx";

interface AuthResetPasswordUpdateContainerProps {}

const AuthUpdatePasswordContainer: FC<AuthResetPasswordUpdateContainerProps> =
  function AuthResetPasswordUpdateContainer() {
    const tError = useErrorTranslation();
    const [pending, setPending] = useState<boolean>(false);
    const [error, setError] = useState<string | undefined>();

    const onSubmit = async ({ password }) => {
      if (pending) return;
      setPending(true);
      const response: unknown = await callServer(
        RegionShared.Backend.Events.Auth.RecoveryNewPassword,
        {
          password,
        },
      );

      if (response instanceof RpcMpProviderSuccessResponse) {
        await AuthMpProvider.goToCreatePin();
      } else {
        const { message } = response as { message: string };
        setError(tError(message));
      }
      setPending(false);
    };

    return <AuthUpdatePassword onSubmit={onSubmit} pending={pending} error={error} />;
  };

export default AuthUpdatePasswordContainer;
